<template>
  <div>
    <b-navbar variant="faded" type="dark" class="contentHeader p-0 w-100">
      <!--Links-->
      <div class="linksWrapper">
        <b-nav align="right">
          <b-nav-item title="Home">
            <router-link to="/">
              <i class="fas fa-home" style="top: 2px;position: relative;"></i>
            </router-link>
          </b-nav-item>
        </b-nav>
      </div>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "SecondaryHeader1"
};
</script>

<style lang="scss">
.contentHeader {
  width: 100%;
  background: rgb(52, 63, 75);
  height: 61px;
  color: $color-white;
}

/*------Page Links------*/
.badge-warning {
  color: $color-white;
  background-color: $color-red;
  font-size: 10px;
  vertical-align: top;
  padding-right: 0.4em;
  padding-left: 0.4em;
}

.linksWrapper {
  ul {
    li {
      a {
        img {
          position: relative;
          width: 16px;
          height: 16px;
        }
        i {
          position: relative;
          width: 16px;
          height: 16px;
          color: #a8bec9;
          position: relative;
        }
        display: block;
        color: #8E9194;
        text-align: center;
        padding: 0px 4px;
        text-decoration: none;
      }
      float: left;
      top: 0;
      position: relative;
    }
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: transparent;
    float: right;
  }
  position: absolute;
  right: 2%;
}
</style>